import { render, staticRenderFns } from "./SvgView.vue?vue&type=template&id=4f900ea7&"
import script from "./SvgView.vue?vue&type=script&lang=js&"
export * from "./SvgView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports